import { useEffect, useState } from "react";
import {  useNavigate } from "react-router-dom";
import { apiUrls } from "../utils/apiUrls";
import { ErrorMessage, SuccessMessage } from "../helpers/Index";
import { callAPIWithoutAuth } from "../utils/apiUtils";
import { useDispatch } from "react-redux";
import { setUser } from "../store/userSlice";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../languages";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showotp, setShowotp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const loginToApp = async () => {
    try {
      setLoading(true);
      const response = await callAPIWithoutAuth(apiUrls.login, {}, "POST", {
        email: email,
      });
      setLoading(false);
      if (response.data.success) {
        SuccessMessage(response.data.message);
        setShowotp(true);
        setTimer(30);
      } else {
        ErrorMessage(response.data.message);
      }
    } catch (e) {
      setLoading(false);
      ErrorMessage(e.message);
    }
  };

  const getSessionId = () => {
    let sessionId = localStorage.getItem("session_id");

    if (!sessionId) {
      sessionId = "sess_" + Math.random().toString(36).substring(2, 15);
      localStorage.setItem("session_id", sessionId);
    }

    return sessionId;
  };
  const dispatch = useDispatch();

  const Verifyotp = async () => {
    try {
      setLoading(true);
      const response = await callAPIWithoutAuth(apiUrls.verifyotp, {}, "POST", {
        email: email,
        otp: otp,
        session_id: getSessionId(),
      });
      setLoading(false);
      if (response.data.success) {
        let datas = response?.data?.data;
        setEmail("");
        setOtp("");
        const modalEl = document.getElementById("exampleModal");

        if (modalEl) {
          let modal = window.bootstrap.Modal.getInstance(modalEl);
          if (!modal) modal = new window.bootstrap.Modal(modalEl);
          modal.hide();
        }
        dispatch(
          setUser({
            user: datas?.user,
            token: datas?.token,
          }),
        );
        localStorage.setItem("accessToken", datas?.token);
        localStorage.setItem("userData", JSON.stringify(datas?.user));
        SuccessMessage(response.data.message);
        setShowotp(true);
        navigate("/dashboard");
      } else {
        ErrorMessage(response.data.message);
      }
    } catch (e) {
      setLoading(false);
      ErrorMessage(e.message);
    }
  };

  const handleSubmit = (type) => {
    if (type === "otp") {
      Verifyotp();
    } else {
      loginToApp();
    }
  };
  useEffect(() => {
    let interval = null;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const resendOtp = async () => {
    if (!email) {
      ErrorMessage("Email is required");
      return;
    }

    try {
      setResendLoading(true);

      const response = await callAPIWithoutAuth(
        apiUrls.login, // using same login API to resend OTP
        {},
        "POST",
        { email: email },
      );

      setResendLoading(false);

      if (response.data.success) {
        SuccessMessage("OTP resent successfully");
        setTimer(30); // start 30 sec timer
      } else {
        ErrorMessage(response.data.message);
      }
    } catch (e) {
      setResendLoading(false);
      ErrorMessage(e.message);
    }
  };
  const { language } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id:
          "914773699348-ae5gjoqi4g524f520r64eu30iquic4m2.apps.googleusercontent.com",
        callback: handleGoogleResponse,
        use_fedcm_for_prompt: false, // 👈 add this line
      });
    }
    // eslint-disable-next-line
  }, []);

  const handleGoogleResponse = async (response) => {
    const token = response.credential || response.access_token;
    try {
      setLoading(true);
      const res = await callAPIWithoutAuth(
        apiUrls.googleLogin, // you'll add this URL
        {},
        "POST",
        { token: token, session_id: getSessionId() }, // Google ID token
      );
      setLoading(false);

      if (res.data.success) {
        let datas = res?.data?.data;
        dispatch(setUser({ user: datas?.user, token: datas?.token }));
        localStorage.setItem("accessToken", datas?.token);
        localStorage.setItem("userData", JSON.stringify(datas?.user));
        SuccessMessage(res.data.message);

        // close modal
        const modalEl = document.getElementById("exampleModal");
        if (modalEl) {
          let modal = window.bootstrap.Modal.getInstance(modalEl);
          if (!modal) modal = new window.bootstrap.Modal(modalEl);
          modal.hide();
        }

        navigate("/dashboard");
      } else {
        ErrorMessage(res.data.message);
      }
    } catch (e) {
      setLoading(false);
      ErrorMessage(e.message);
    }
  };
 
  return (
    <>
      <div
      className="modal fade login-modal"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row align-items-center">
                {/* LEFT IMAGE */}
                <div className="col-md-6 order-md-0 order-1">
                  <div className="login-left mt-3 mt-md-0 position-relative">
                    <div className="login-left-content position-relative">
                      <div className="login-logo mb-4">
                        <img src="/image/logo.png" alt="アリーズケバブ" />
                      </div>
                      <h4>
                        {t.LoginContent.heading}
                        <span> {t.LoginContent.brandName}</span>
                      </h4>
                      <p> {t.LoginContent.subHeading}</p>
                      <div className="login-left-list mt-4">
                        <p>
                          <span className="me-2">
                            <img src="/image/check.svg" alt="" />
                          </span>{" "}
                          {t.LoginContent.feature1}
                        </p>
                        <p>
                          <span className="me-2">
                            <img src="/image/check.svg" alt="" />
                          </span>{" "}
                          {t.LoginContent.feature2}
                        </p>
                        <p>
                          <span className="me-2">
                            <img src="/image/check.svg" alt="" />
                          </span>{" "}
                          {t.LoginContent.feature3}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT FORM */}
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn-close login-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <img src="/image/times-circle.svg" alt="閉じる" />
                  </button>

                  <div className="login-fileds">
                    <div className="login-header mb-4 text-center">
                      <h4 className="mb-2"> {t.welcomeBack}</h4>
                      <p> {t.signInAccess}</p>
                    </div>

                    {/* EMAIL */}
                    <div className="form-group mb-3 position-relative">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t.enterEmail}
                        name="email"
                        disabled={showotp}
                        value={email || ""}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <img src="/image/profile.svg" alt="" />
                    </div>

                    {/* PASSWORD */}
                    {showotp && (
                      <>
                        <div className="form-group mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t.enterOtp}
                            name="otp"
                            value={otp || ""}
                            onChange={(e) => setOtp(e.target.value)}
                          />
                          <img src="/image/lock.svg" alt="" />
                        </div>

                        <div className="text-end mb-3">
                          {timer > 0 ? (
                            <small className="text-muted">
                              {t.resendOtpIn}
                              {timer}s
                            </small>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={resendOtp}
                              disabled={resendLoading}
                            >
                              {resendLoading
                                ? `${t.resending}...`
                                : t.resendOtp}
                            </button>
                          )}
                        </div>
                      </>
                    )}

                    {/* SUBMIT */}
                    <div className="form-group mb-3 position-relative">
                      <button
                        type="button"
                        className="btn primary-btn w-100"
                        onClick={() => handleSubmit(showotp ? "otp" : "login")}
                        disabled={loading}
                      >
                        {loading ? `${t.signingIn}...` : t.signIn}
                      </button>
                    </div>

                    {/* SOCIAL LOGIN */}
                    <div className="or-option text-center">
                      <span className="d-block position-relative">
                        {t.orSignInWith}
                      </span>
                      <div className="d-flex align-items-center justify-content-center gap-3">
                       <button
  type="button"
                          className="option-signin blue d-flex align-items-center justify-content-center gap-2"
                          onClick={() => {
                            const clientId = "2010257140";
                            const redirectUri = encodeURIComponent(
                              window.location.origin + "/line-callback",
                            );
                            const state = Math.random()
                              .toString(36)
                              .substring(2);
                            const lineAuthUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=profile%20openid%20email`;
                            window.location.href = lineAuthUrl;
                          }}
                        >
                          <img src="/image/line.svg" alt="LINE" />
                          {t.line}
                        </button>
                        <button
                          type="button"
                          className="option-signin white d-flex align-items-center justify-content-center gap-2 "
                          onClick={() => {
                            const client =
                              window.google.accounts.oauth2.initTokenClient({
                                client_id:
                                  "914773699348-ae5gjoqi4g524f520r64eu30iquic4m2.apps.googleusercontent.com",
                                scope: "email profile",
                                callback: handleGoogleResponse,
                              });
                            client.requestAccessToken();
                          }}
                        >
                          <img src="/image/google.svg" alt="Google" />
                          {t.google}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
